import React, { useEffect, useState } from 'react'

import { onCheckCondition } from 'designer/component/action/condition/Action'
import { debounceCallback } from 'utility/debounceCallback.util'
import PropWrapper from './PropWrapper'
import {
  updateFieldValue,
  updateMapResponse,
  updateWidgetData,
} from './DataControl'
import objectPath from 'object-path'
import MTableArray from 'designer/component/element/table/MTableArray'

const Children = ({ dataProps }) => {
  const { props, designContext, fieldProps, fieldName, fieldKey, errors } =
    dataProps
  const {
    jsonForm,
    setFieldFormData,
    setFieldSearchData,
    setFieldAllData,
    setIsInputSearch,
    isUiChanged,
    setIsUiChanged,
  } = designContext
  const { uischema, config } = props
  const { dynamicData = {}, onUpdateFormData = () => {} } = config

  const formData = jsonForm.formData
  const { uiKey, uiName, value, data, renderWidget, mapResponse, isSearch } =
    fieldProps
  const [isUpdate, setIsUpdate] = useState(false)
  let syncKey = objectPath.get(uischema, 'loadData.syncSetting.key')
  let isLoadSYNC = objectPath.get(uischema, 'loadData.method') === 'SYNC'
  let tableKey = isLoadSYNC ? syncKey : uischema.key

  const updateData = async (value) => {
    updateFieldValue({ ...dataProps, value })
    objectPath.set(isUiChanged, `arrayTable.${tableKey}`, value)
    setIsUiChanged(isUiChanged)
    setIsUpdate(true)
  }

  const updateSyncData = async (key, name, value) => {
    if (isSearch) {
      setFieldSearchData(uischema, key, value, {
        isSearch,
      })
      setFieldSearchData(uischema, name, value, {
        isSearch,
      })
      setFieldAllData(key, value)
      setFieldAllData(name, value)
      onUpdateFormData(name, value, true)
    } else {
      setFieldFormData(key, value)
      setFieldFormData(name, value)
      setFieldAllData(key, value)
      setFieldAllData(name, value)
      onUpdateFormData(name, value)
    }
    setIsUpdate(true)
  }

  useEffect(() => {
    updateMapResponse(dataProps)
  }, [mapResponse])

  useEffect(() => {
    updateWidgetData(dataProps)
  }, [renderWidget])

  useEffect(() => {
    if (isUpdate) {
      debounceCallback(
        onCheckCondition,
        [designContext, data, [uiKey]],
        'on-check-condition',
      )
      setIsUpdate(false)
      debounceCallback(setIsInputSearch, [uiKey], 'onInputUpdate')
    }
  }, [isUpdate])

  return (
    <MTableArray
      fieldName={fieldName}
      fieldKey={fieldKey}
      config={config}
      title={uischema.title}
      uischema={uischema}
      data={data}
      value={value}
      uiKey={uiKey}
      uiName={uiName}
      formData={formData}
      updateData={updateData}
      updateSyncData={updateSyncData}
      errors={errors}
      dynamicData={dynamicData}
    />
  )
}

const CustomTableControl = (props) => {
  return (
    <PropWrapper {...props}>
      {({ dataProps }) => <Children dataProps={dataProps} />}
    </PropWrapper>
  )
}

export default CustomTableControl
